import PropTypes from 'prop-types';
import { TextInput } from '@mantine/core';
import { IconSearch } from '@tabler/icons-react';
import { useState } from 'react';

const SearchInput = (props) => {
  const { placeholder, onSearch } = props;
  const [searchValue, setSearchValue] = useState('');

  const handleSubmit = () => {
    onSearch(searchValue);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSubmit();
    }
  };

  return (
    <TextInput
            variant='search'
            placeholder={placeholder}
            rightSection={<IconSearch width={20} height={20} color='var(--mantine-color-brand-5)' />}
            rightSectionProps={{
              onClick: () => handleSubmit(),
            }}
            onChange={(e) => setSearchValue(e.target.value)}
            onKeyDown={handleKeyDown}
        />
  );
};

export default SearchInput;

SearchInput.propTypes = {
  placeholder: PropTypes.string,
  onSearch: PropTypes.func.isRequired,
};
